import { defineCollection } from "@rebasepro/cms-types";
import { SAY } from "../words";

// What the AI host costs, per UTC day and kind (songbuzz_ai_spend): tts is the voice, comment the written lines,
// prerecord the fallback takes recorded ahead. The daily cap (SONGBUZZ_AI_DAILY_USD) is checked against it.
// backend/functions/songbuzz.ts creates and writes it. `day` is a date in the database, text here.
const aiSpendCollection = defineCollection({
    name: "AI spend",
    singularName: "AI spend",
    slug: "ai_spend",
    table: "songbuzz_ai_spend",
    description: "What the AI host cost per day: voice (tts), written comments, and prerecorded takes.",
    securityRules: [{ operation: "select", roles: ["admin"] }],
    properties: {
        day: { name: "Day", description: "UTC", type: "string", isId: "manual", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "day" } } },
        kind: { name: "For", type: "string", isId: "manual", admin: { readOnly: true, Preview: "../../admin/src/previews/Words", customProps: { say: "aiKind" } } },
        usd: { name: "Cost", type: "number", columnType: "double precision", defaultValue: 0, validation: { required: true }, admin: { readOnly: true, format: { style: "currency", currency: "USD", minimumFractionDigits: 2, maximumFractionDigits: 2 } } },
        calls: { name: "Requests to Gemini", type: "number", columnType: "integer", defaultValue: 0, validation: { required: true }, admin: { readOnly: true } },
        tokens: { name: "Tokens", type: "number", columnType: "bigint", defaultValue: 0, validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "CircleDollarSign",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["day", "desc"],
        display: {
            title: ({ entity }) => `${SAY.aiKind(entity.values.kind)} · ${SAY.day(entity.values.day)}`,
            subtitle: ({ entity }) => `$${Number(entity.values.usd ?? 0).toFixed(2)} · ${entity.values.calls ?? 0} requests`,
        },
        listProperties: ["usd", "calls", "tokens"],
    },
});

export default aiSpendCollection;
